import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { CargoActionDocumentStatus } from "__generated__/enums";
import { getCargoDocumentStatusColor } from "view/documents/utils/DocumentUtils";

const CargoDocumentStatusSelect = <Multiple extends boolean = false,>({ value, onChange, multiple }: Omit<SelectProps<CargoActionDocumentStatus, Multiple>, "fetchOptions">) => {
	const fetchOptions = Object.values(CargoActionDocumentStatus);

	return (
		<Select
			fetchOptions={fetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `ACTION_DOCUMENT_STATUS_${option}` })}
			getOptionColor={getCargoDocumentStatusColor}
			value={value}
			onChange={onChange}
			multiple={multiple}
		/>
	);
};

export default CargoDocumentStatusSelect;
